var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PluginComponent',{attrs:{"plugin-url":"/plugins/SlideshowPlugin/SlideshowPlugin.81d79a693336aea327c6.umd.min.js"}})}
var staticRenderFns = []

export { render, staticRenderFns }